// extracted by mini-css-extract-plugin
export default {"wrapper":"Hero_wrapper__k2W7p"};